import axiosInstance from './AxiosInstance';

const API_URL = 'skills';

export const getSkills = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching skills', error);
        throw error;
    }
};

export const getSkillById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching skill with id ${id}`, error);
        throw error;
    }
};

export const createSkill = async (skill) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, skill);
        return response.data;
    } catch (error) {
        console.error('Error creating skill', error);
        throw error;
    }
};

export const updateSkill = async (id, skill) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...skill });
        return response.data;
    } catch (error) {
        console.error(`Error updating skill with id ${id}`, error);
        throw error;
    }
};

export const deleteSkill = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting skill with id ${id}`, error);
        throw error;
    }
};

